import { createContext, useContext, useReducer } from 'react';
import { BudgetUnitSearchState, BudgetUnitSearchReducer, ACTION_TYPES } from './budget-unit-search-reducer';

const BudgetUnitSearchContext = createContext<BudgetUnitSearchState | undefined>(undefined);
const BudgetUnitSearchDispatchContext = createContext({} as any);

const BudgetUnitSearchProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: BudgetUnitSearchState = {
        parameters: {},
        searchTrigger: 0,
        drawer: { open: false },
    };
    const [state, dispatch] = useReducer(BudgetUnitSearchReducer, initialState);
    return (
        <BudgetUnitSearchContext.Provider value={state}>
            <BudgetUnitSearchDispatchContext.Provider value={dispatch}>
                {children}
            </BudgetUnitSearchDispatchContext.Provider>
        </BudgetUnitSearchContext.Provider>
    );
};

const useBudgetUnitSearchState = () => {
    const context = useContext(BudgetUnitSearchContext);
    if (!context) throw new Error('useBudgetUnitSearchState must be used within BudgetUnitSearchProvider');
    return context;
};

const useBudgetUnitSearchDispatch = () => {
    const context = useContext(BudgetUnitSearchDispatchContext);
    if (!context) throw new Error('useBudgetUnitSearchDispatch must be used within BudgetUnitSearchProvider');
    return context;
};

export { BudgetUnitSearchProvider, useBudgetUnitSearchState, useBudgetUnitSearchDispatch, ACTION_TYPES };
